import React from "react";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Shared version of Rightwork's customized MUI select pattern. Labels should
// use id={`${id}-label`} and htmlFor={id}; option values retain their types.
export default function RightworkSelect({ id, value, onChange, options, disabled = false, error = false, describedBy, multiple = false, renderValue, onOpen, onClose }) {
  return <Select id={id} labelId={`${id}-label`} value={value} onChange={onChange}
    multiple={multiple} renderValue={renderValue} onOpen={onOpen} onClose={onClose}
    fullWidth size="small" displayEmpty disabled={disabled} error={error} IconComponent={ExpandMoreIcon}
    SelectDisplayProps={{ "aria-describedby": describedBy }}
    sx={{
      bgcolor: "white", color: "#334155", borderRadius: "8px", fontSize: "14px", minHeight: 42,
      "& .MuiSelect-select": { py: "10px", pl: "14px" },
      "& .MuiSelect-icon": { color: "#64748b", right: 10, fontSize: 20 },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#cbd5e1" },
      "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#94a3b8" },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#6d28d9", borderWidth: 2 },
      "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "#e11d48" },
      "&.Mui-disabled": { bgcolor: "#f1f5f9" },
    }}
    MenuProps={{
      PaperProps: { sx: { mt: 0.5, borderRadius: "8px", border: "1px solid #e2e8f0", maxHeight: 320, maxWidth: "calc(100vw - 32px)", boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)" } },
      MenuListProps: { sx: { p: 0.5 } },
    }}>
    {options.map((option) => <MenuItem key={option.value} value={option.value} disabled={option.disabled}
      sx={{
        borderRadius: "6px", minHeight: 36, py: 1, px: 1.5, fontSize: "14px", color: "#334155", whiteSpace: "normal",
        "&:hover": { bgcolor: "#f8fafc" },
        "&.Mui-selected": { bgcolor: "#f5f3ff", color: "#6d28d9", fontWeight: 500 },
        "&.Mui-selected:hover": { bgcolor: "#ede9fe" },
        "&.Mui-focusVisible": { bgcolor: "#ede9fe", outline: "2px solid #6d28d9", outlineOffset: -2 },
      }}>{multiple && <Checkbox checked={value.includes(option.value)} size="small" disableRipple tabIndex={-1} sx={{ p: 0, mr: 1, color: "#94a3b8", "&.Mui-checked": { color: "#6d28d9" } }} />}{option.label}</MenuItem>)}
  </Select>;
}
